// 渠道
import { useLazyQuery } from "@apollo/react-hooks"
import { generateQuery } from "Methods/query"
import { tableInitialVariables } from "Methods/table"

const tableName = "channel"
const query = generateQuery(tableName)
export function useFetchChannel() {
    const [ fetchData, { data }] = useLazyQuery(query, {
        variables: tableInitialVariables,
    })
    const { channel = [] } = data || {}
    return {
        fetchChannel: fetchData,
        channel,
    }
}
export function useFetchWeChatChannel() {
    const [ fetchData, { data }] = useLazyQuery(query, {
        variables: {...tableInitialVariables, where: { type_name: { _eq: "wechat" } }},
    })
    const { channel = [] } = data || {}
    return {
        fetchWeChatChannel: fetchData,
        weChatChannel: channel.length ? channel[0] : null,
    }
}
